import { useRef } from "react"

/**
 * @deprecated Unsure if this works well in all cases, and it lacks type safety.
 * When we have time, switch to something like https://usehooks-ts.com/react-hook/use-debounce-callback
 *
 * @param callback
 * @param delay
 */
export const useDebouncer = (callback: any, delay: number | null = 200) => {
    // save result of debounce across component lifecycle
    const debounceRef = useRef(
        debounce((...args: any) => {
            if (callback) {
                callback(...args)
            }
        }, delay || 0),
    )

    return debounceRef.current
}

const debounce = (func: any, wait: number) => {
    let timeout: number

    return function executedFunction(...args: any[]) {
        const later = () => {
            window.clearTimeout(timeout)
            func(...args)
        }

        window.clearTimeout(timeout)
        timeout = window.setTimeout(later, wait)
    }
}
